export const countries = [
{
	"name": "USA",
	"abbreviation": "US"
},
{
	"name": "Canada",
	"abbreviation": "CA"
}]


// WEBPACK FOOTER //
// ./src/utils/constants/countries.js